import { create, clickable, fillable, text, value, visitable } from 'ember-cli-page-object';
import flashMessage from 'core/test-support/pages/components/flash-message';
export default create({
  visit: visitable('/private/registries/:registry/boxes/:box/versions/:version/edit'),
  title: text('[data-test-title]'),
  subtitle: text('[data-test-subtitle]'),
  name: value('[data-test-name]'),
  description: value('[data-test-description]'),
  fillInDescription: fillable('[data-test-description]'),
  update: clickable('[data-test-update]'),
  flash: flashMessage
});